import React from 'react'
import './page-titles.css'

const PageTitles = ({ match, linkTo, handleClick, title, subtitle }) => (
  <div className="page-titles">
    <div className="page-titles__title text--small-serif">{title}</div>
    <div onClick={handleClick} className="page-titles__subtitle text--small">
      <div className="page-titles__link">{subtitle}</div>
    </div>
  </div>
)

export default PageTitles



// WEBPACK FOOTER //
// ./src/components/page-titles/index.js